var _rect, _path, _path2, _path3, _g, _path4, _path5, _circle, _circle2, _circle3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsharpTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 80,
    width: 200,
    height: 240,
    rx: 8,
    stroke: "black",
    strokeWidth: 4,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 140 L160 140 C175 140 185 150 185 165 C185 180 175 190 160 190 L140 190 L140 140Z",
    stroke: "#3B82F6",
    strokeWidth: 4,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170 155 L200 155",
    stroke: "#3B82F6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 175 L200 175",
    stroke: "#3B82F6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 4,
    fill: "black",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 2,
    r: 6,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 100,
    height: 4,
    fill: "black",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 22,
    r: 6,
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40,
    width: 80,
    height: 4,
    fill: "black",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 42,
    r: 6,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60,
    width: 110,
    height: 4,
    fill: "black",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 62,
    r: 6,
    fill: "#3B82F6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260 120 L280 140 L260 160",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240 200 L260 220 L240 240",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 100,
    r: 8,
    fill: "#3B82F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 300,
    r: 8,
    fill: "#EF4444"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 300,
    r: 4,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 160,
    height: 24,
    rx: 4,
    fill: "none",
    stroke: "black",
    strokeWidth: 2,
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 110,
    width: 80,
    height: 4,
    fill: "black",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharpTasks);
export default __webpack_public_path__ + "static/media/csharp-tasks.80bf6395d7c0813f01f8c5b6ffab5d64.svg";
export { ForwardRef as ReactComponent };